export enum ModalDesktopSize {
  S = 's',
  M = 'm',
  L = 'l',
}
